const PATTERNS = ["nnwwn", "wnnnw", "nwnnw", "wwnnn", "nnwnw", "wnwnn", "nwwnn", "nnnww", "wnnwn", "nwnwn"];
const NARROW = 1;
const WIDE = 3;

// Interleaved 2 of 5 (ITF) — padrão dos boletos bancários (44 dígitos)
export const ItfBarcode = ({ code, height = 56, className = "", testId = "itf-barcode" }) => {
  const digits = (code || "").replace(/\D/g, "");
  if (!digits || digits.length % 2 !== 0) return null;
  const rects = [];
  let x = 0;
  const bar = (w) => { rects.push({ x, w }); x += w; };
  const space = (w) => { x += w; };
  bar(NARROW); space(NARROW); bar(NARROW); space(NARROW);
  for (let i = 0; i < digits.length; i += 2) {
    const a = PATTERNS[Number(digits[i])];
    const b = PATTERNS[Number(digits[i + 1])];
    for (let k = 0; k < 5; k++) {
      bar(a[k] === "w" ? WIDE : NARROW);
      space(b[k] === "w" ? WIDE : NARROW);
    }
  }
  bar(WIDE); space(NARROW); bar(NARROW);
  const total = x;
  return (
    <svg data-testid={testId} className={className} viewBox={`0 0 ${total} ${height}`} preserveAspectRatio="none"
      width="100%" height={height} role="img" aria-label={`Código de barras ${digits}`}>
      <rect x="0" y="0" width={total} height={height} fill="#fff" />
      {rects.map((r, i) => <rect key={i} x={r.x} y="0" width={r.w} height={height} fill="#000" />)}
    </svg>
  );
};
